const equipmentData = {
  fr: [
    {
      category: "Régie",
      items: [
        "Console Toft Audio Designs ATB24",
        "Enceintes Neumann KH 310",
        "Ordinateur Mac Studio équipé de Logic Pro",
        "Divers preamps et compresseurs analogiques",
      ],
    },
    {
      category: "Microphones",
      items: [
        "Rode Classic II",
        "Townsend Sphere",
        "2x AKG C414",
        "2x Neumann KM184",
        "2x Extinct Audio BM6",
        "2x Sennheiser 421",
        "2x Sennheiser e935",
        "2x Sennheiser e609",
        "Shure sm81",
        "Audio Technica AE2500",
        "Yamaha Subkik",
        "2x Shure sm57",
        "Valise de micros pour batterie Audix (d6, d4, d2)",
      ],
    },
    {
      category: "Instruments et amplis",
      items: [
        "Piano droit Pleyel",
        "Guitare Martin HD 28",
        "Fender Telecaster (american standard)",
        "Gibson Les Paul",
        "Takamine",
        "Fender Jazz Bass (frettée)",
        "Fender Jazz Bass (fretless)",
        "Orgue KeyB",
        "Farfisa Compact mini",
        "Nord Electro 6HD",
        "Nord Lead",
        "Juno 106",
        "Access Virus",
        "Diverses percussions",
        "Hammered Dulcimer Dusty Keys",
        "Ampli Vox AC30 Blue Alinco",
        "Ampli Fender Bassman Silverface (1975)",
        "Ampli Fender Twin Reverb",
        "Ampli Trace Eliot GP12",
      ],
    },
    {
      category: "Plugins",
      items: [
        "UAD (beaucoup !)",
        "Soundtoys (collection intégrale)",
        "Waves",
        "Native Instruments Komplete",
        "Arturia (collection intégrale)",
        "Oeksound",
        "Melodyne",
        "Fabfilter (collection intégrale)",
        "Izotope RX10",
        "Pianoteq",
        "Musio",
      ],
    },
  ],

  en: [
    {
      category: "Control Room",
      items: [
        "Desk: Toft Audio Designs ATB24",
        "Speakers : Neumann KH 310",
        "Mac Studio with Logic Pro",
        "Various preamps and compressors",
      ],
    },
    {
      category: "Microphones",
      items: [
        "Rode Classic II tube microphone",
        "Townsend Sphere",
        "2x AKG C414",
        "2x Neumann KM184",
        "2x Extinct Audio BM6",
        "2x Sennheiser 421",
        "2x Sennheiser e935",
        "2x Sennheiser e609",
        "Shure sm81",
        "Audio Technica AE2500",
        "Yamaha Subkik",
        "2x Shure sm57",
        "Audix drum mics (d6, d4, d2)",
      ],
    },
    {
      category: "Instruments and Amps",
      items: [
        "Pleyel upright Piano",
        "Martin HD 28 guitar",
        "Fender Telecaster (American Standard)",
        "Gibson Les Paul",
        "Takamine",
        "Fender Jazz Bass (fretted)",
        "Fender Jazz Bass (fretless)",
        "KeyB Organ",
        "Farfisa Compact Mini",
        "Nord Electro 6HD",
        "Nord Lead",
        "Juno 106",
        "Access Virus",
        "Various percussion",
        "Hammered Dulcimer (Dusty Keys)",
        "Vox AC30 Blue Alinco Amp",
        "Fender Bassman Silverface (1975) amp",
        "Fender Twin Reverb Amp",
        "Trace Eliot GP12 Amp",
      ],
    },
    {
      category: "Plugins",
      items: [
        "UAD (many!)",
        "Soundtoys (complete)",
        "Waves",
        "Native Instruments Komplete",
        "Arturia (complete)",
        "Oeksound",
        "Melodyne",
        "Fabfilter (complete)",
        "Izotope RX10",
        "Pianoteq",
        "Musio",
      ],
    },
  ],
};

export default equipmentData;